import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingSpinner: React.FC = () => {
  return (
    <>
      <div className="d-flex justify-content-center loading-overlay">
        <Spinner animation="border" variant="primary" />
      </div>
    </>
  );
};

export default LoadingSpinner;
